// import { GET_ALL_FILAS, GET_ALL_OPERADORES_MONITOR } from './mutation-types'
import { GET_ALL_FILAS } from './mutation-types'

export default {
  [GET_ALL_FILAS]: (state, filas) => {
    state.filas = filas
  },
  // [GET_ALL_OPERADORES_MONITOR]: (state, operadoresMonitor) => {
  //   console.log('GET_ALL_OPERADORES_MONITOR', operadoresMonitor)
  //   state.operadoresMonitor = operadoresMonitor
  // },
}
